import * as Constants from './constants'

export const dashboardListRequest = function dashboardListRequest (formData) {  
  return {
    type: Constants.DASHBOARD_LIST_REQUESTING,
    formData
  }
}

export const dashboardListSuccess = function dashboardListSuccess (data) {  
  return {
    type: Constants.DASHBOARD_LIST_SUCCESS,
    data
  }
}

export const dashboardListError = function dashboardListError (error) {  
  return {
    type: Constants.DASHBOARD_LIST_ERROR,
    error
  }
}

export const dashboardSinhNhatListRequest = function dashboardSinhNhatListRequest (formData) {  
  return {
    type: Constants.DASHBOARD_SINHNHAT_LIST_REQUESTING,
    formData
  }
}

export const dashboardSinhNhatListSuccess = function dashboardSinhNhatListSuccess (data) {  
  return {
    type: Constants.DASHBOARD_SINHNHAT_LIST_SUCCESS,
    data
  }
}

export const dashboardSinhNhatListError = function dashboardSinhNhatListError (error) {  
  return {
    type: Constants.DASHBOARD_SINHNHAT_LIST_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/Dashboard/actions.js